import HttpResponse from "../../../../utils/http/http.response";

export enum OrderOptimizerListResponseItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerListResponseItemOrders = {
  humanId: number;
  startTime: Date;
  cargoCompany: string;
  taxiCorporation: string;
  haltingTimeBefore: number | null;
};

export type OrderOptimizerListResponseItemRoute = {
  orderHumanId: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerListResponseItem = {
  id: string;
  score: number;
  status: OrderOptimizerListResponseItemStatus;
  route: OrderOptimizerListResponseItemRoute[];
  orders: OrderOptimizerListResponseItemOrders[];
  reviewedBy: string | null;
  reviewedAt: Date | null;
};

type OrderOptimizerListResponse = HttpResponse<{
  data: OrderOptimizerListResponseItem[];
  totalCount: number;
}>;

export default OrderOptimizerListResponse;
